import type React from "react";
import { useMemo } from "react";

import RequiredMarker from "./RequiredMarker";

const baseClass: string = "block text-md font-medium font-sora text-[#505963] mb-2";

// Standardized label component for consistency
const FormLabel: React.FC<{
    children: React.ReactNode;
    htmlFor: string;
    required?: boolean;
    classOverride?: string;
    classAppend?: string;
    suffix?: React.ReactNode;
}> = ({ children, required = false, htmlFor, classOverride, classAppend, suffix }) =>
{
    const className: string = useMemo(() =>
    {
        let clsName: string;

        if (classOverride)
        {
            clsName = classOverride;
        }
        else
        {
            clsName = baseClass;
        }

        if (classAppend)
        {
            clsName = clsName + " " + classAppend;
        }

        return clsName;
    }, [classOverride, classAppend]);

    return (
        <label
            htmlFor={htmlFor}
            className={className}
        >
            <span className="flex items-center gap-2">
                {/* Inline (not inline-flex) so the asterisk follows the last word even when the label wraps. */}
                <span>
                    {children}
                    {required && <RequiredMarker />}
                </span>
                {suffix}
            </span>
        </label>
    );
};

export default FormLabel;